<template>
  <div class="course__card_box">
    <div class="title">专属课程</div>
    <ul>
      <li v-for="(item, keys) in courseList" :key="keys">
        <course-card :isUnlock="isUnlock" :key="keys" :item="item"></course-card>
      </li>
    </ul>
  </div>
</template>

<script>
import { reqProducts } from '@/api/home';
import { resetProductData } from '@/utils/tools';
import CourseCard from './CourseCard.vue';

export default {
  props: {
    userInfo: {
      type: Object,
      default: () => ({}),
    },
    productIds: {
      type: Array,
      default: () => [],
    },
    activeTab: {
      type: Number,
      default: 20,
    },
    userMemberInfo: {
      type: Object,
      default: () => ({
        level: 0, // 0 普通用户 10 试用会员 20 普通会员 30 高级会员
        levelName: '普通用户',
        deadlineStartTime: '',
        deadlineEndTime: '', // 会员到期时间
        isTryoutMember: null, // 是否领取过试用会员
        beforeMemberLevel: null, // 上一次会员等级
      }),
    },
  },
  components: {
    CourseCard,
  },
  data() {
    return {
      courseList: [],
    };
  },
  watch: {
    productIds: {
      handler(value) {
        if (value.length) {
          const endPoint = this.$root.$data.isApp ? 2 : 4;
          reqProducts(value, endPoint).then((res) => {
            if (res.code === 0) {
              console.log(res.data);
              this.courseList = resetProductData(res.data);
            }
          });
        }
      },
      deep: true,
      immediate: false,
    },
  },
  computed: {
    isUnlock() {
      const { level } = this.userMemberInfo;
      const { id } = this.userInfo;
      const flag = id && ((level === 30 && this.activeTab === 30) || ([10, 20, 40, 50, 60].includes(level) && this.activeTab === 20));
      return !!flag;
    },
  },
};

</script>

<style scoped lang="scss">
.course__card_box {
  .title {
    margin-left: 36px;
    margin-bottom: 22px;
    height: 40px;
    font-size: 29px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 40px;
  }

  ul {
    white-space: nowrap;
    overflow-x: auto;
    overflow-y: hidden;

    &::-webkit-scrollbar {
      display: none;
    }

    li {
      display: inline-block;
      margin-right: 18px;

      &:first-child {
        margin-left: 36px;
      }

      &:last-child {
        margin-right: 36px;
      }

      // background: #fff;
      // border-radius: 18px;
    }
  }
}
</style>
